<template>
  <tbody>
    <tr
      v-for='(number) of numberOfRows'
      :key='number'
    >
      <td
        v-for='(header, index) of headers'
        :key='index'
      >
        <v-skeleton-loader
          class='w-table-cell-skeleton'
          type='table-cell'
        />
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  name: 'WorkTableBodySkeleton',
  props: {
    headers: { type: Array, default: () => [] },
    numberOfRows: { type: Number, default: 10 }
  }
};
</script>

<style lang='scss' scoped>
.w-table-cell-skeleton ::v-deep .v-skeleton-loader__table-cell {
  width: 100%;
}
</style>
